var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2151 4.23359C10.2151 3.10896 9.30341 2.19727 8.17878 2.19727C7.05415 2.19727 6.14246 3.10896 6.14246 4.23359V7.62747C6.14246 8.7521 7.05415 9.6638 8.17878 9.6638C9.30341 9.6638 10.2151 8.7521 10.2151 7.62747V4.23359Z",
    stroke: "#FECE2F",
    strokeWidth: 1.16361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43091 7.63086C3.43091 8.89102 3.9315 10.0996 4.82257 10.9906C5.71363 11.8817 6.92218 12.3823 8.18234 12.3823C9.44249 12.3823 10.651 11.8817 11.5421 10.9906C12.4332 10.0996 12.9338 8.89102 12.9338 7.63086",
    stroke: "#FECE2F",
    strokeWidth: 1.16361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46826 15.0996H10.8985",
    stroke: "#FECE2F",
    strokeWidth: 1.16361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17981 12.3828V15.0979",
    stroke: "#FECE2F",
    strokeWidth: 1.16361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2906,
    height: 16.2906,
    fill: "white",
    transform: "translate(0.0354004 0.841797)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.fdabbbc33ebb4c0b80d0aad63bf653fe.svg";
export { ForwardRef as ReactComponent };